import React, { useState } from 'react';
import './ImageHighlight.css';
import { navigate } from 'gatsby';
import { Badge, Label, Icon, Link } from '@nooz-optics/nooz-components-lib';
import { Image } from '../../Media/Image/index';
import { IButton, IImage, Ilabel } from '../../../../utils/types/contentful';
import { returnLocalisedPath } from '../../../../utils/globals';
import { withLocale } from '../../../../utils/hocs';
import { Button } from '../../Elements';

export interface ImageHighlightProps {
  image: IImage;
  badges: any;
  label: Ilabel;
  subLabel: Ilabel;
  locale: any;
  button: IButton;
}

export const ImageHighlight = withLocale(
  ({ image, badges, label, subLabel, locale, button }: ImageHighlightProps) => {
    const [isHover, setIsHover] = useState(false);

    return (
      <div
        onClick={() =>
          navigate(returnLocalisedPath(locale[0], button.slug.url))
        }
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        className='w-full cursor-pointer relative'>
        <div className='flex overflow-hidden w-full h-80'>
          <div className='scale-100 hover:scale-105 transform ease-in-out duration-1000'>
            <Image
              {...image}
              objectFit='cover'
              height='100%'
              objectFit='cover'
            />
          </div>
          <div className='absolute top-0'>
            <div className='absolute flex p-5 sm:p-7 top-0'>
              {badges?.items?.map((badge) => (
                <div className='mr-2'>
                  <Badge
                    {...badge}
                    size='sm'
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className='w-full h-full flex flex-row justify-between pointer-events-none mt-3 sm:mt-5'>
          <div className='relative w-full'>
            <div className='mb-2 flex w-full justify-between'>
              <Label
                {...label}
                size='2xl'
              />
            </div>
            {subLabel && (
              <div className='mb-2 mr-2 sm:mr-20'>
                <Label
                  {...subLabel}
                  size='base'
                />
              </div>
            )}
            <div className=''>
              <Link
                label={{ ...button.label, decoration: 'underline' }}
                color={{ classname: 'primary' }}
                type='white'
                size='base'
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
);
